<script setup>
import routes from '@/constants/routes';

const components = {
  'navigation-list': resolveComponent('UiDropdownTrainsNavigation'),
  'c-localized-link': resolveComponent('CLocalizedLink'),
};

const props = defineProps({
  referenceRef: {
    type: Object,
    default: undefined,
  },
  text: {
    type: String,
    default: undefined,
  },
  to: {
    type: String,
    default: undefined,
  },
});
const emit = defineEmits(['redirect']);

const { t } = useI18n();

const isList = computed(() => props.to === routes.WIKI);

const component = computed(() =>
  isList.value ? components['navigation-list'] : components['c-localized-link'],
);
const componentProps = computed(() =>
  isList.value
    ? {
        text: t(props.text),
        referenceRef: props.referenceRef,
        onRedirect: (link) => emit('redirect', link),
      }
    : {
        to: props.to,
        title: t(props.text),
        onClick: () => emit('redirect', props.to),
      },
);
</script>

<template>
  <component
    :is="component"
    class="layout-header-navigation-item"
    v-bind="componentProps"
  >
    <span v-if="!isList" class="layout-header-navigation-item__font">
      {{ $t(text) }}
    </span>
  </component>
</template>
